module.exports = __webpack_public_path__ + "img/petstairs01.d17cfe08.jpg";